export default __webpack_public_path__ + "static/media/default-plate.f2347867.png";